import { useState, useEffect } from 'react';
function useGlossaryTerms() {
  const [glossaryTerms, setGlossaryTerms] = useState<Record<string, string>>(
    {}
  );
  useEffect(() => {
    import('./statementGlossary')
      .then((result) => {
        setGlossaryTerms(result.default);
        return;
      })
      .catch(() => {
        // noop
      });
  }, []);
  return (term: string) => {
    return glossaryTerms[term] || null;
  };
}

export default useGlossaryTerms;
